import script from "./CRM22_002INS.vue?vue&type=script&setup=true&lang=js"
export * from "./CRM22_002INS.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__